import styled from "@emotion/styled"

interface StitchingProps {
	bottomStitchingColor: string
	className?: string
	topStitchingColor: string
}

export const Stitching = (props: StitchingProps) => {
	const { bottomStitchingColor, className, topStitchingColor } = props

	return (
		<Stitches viewBox="0 0 24 24" className={className}>
			<line
				x1="0"
				y1="8"
				x2="24"
				y2="8"
				stroke={topStitchingColor}
				strokeWidth={2}
				strokeDasharray={8}
				strokeLinecap="round"
			/>

			<line
				x1="0"
				y1="16"
				x2="24"
				y2="16"
				stroke={bottomStitchingColor}
				strokeWidth={2}
				strokeDasharray={8}
				strokeLinecap="round"
			/>
		</Stitches>
	)
}

const Stitches = styled.svg`
	position: absolute;
	inset: 0;
`
